<template>
  <div class="embed-content u-box-16by9 u-w10of12 u-marg-x-1of12 u-marg-y-xl u-marg-y-md--sm u-radius u-overflow-hidden">
    <iframe :src="data.urlLink" width="100%" height="100%" frameborder="0" allow="fullscreen" class="u-wrapper-panel" />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>